export class User {
    userid: string = "";
    email: string = ""; 
    username: string = ""; 
    deviceId: string = ""; 
    googleUserId: string = ""; 
    password: string = "";  
    fullName: string = ""; 
    birthday: string = ""; 
    phoneNumber: string = ""; 
    address: string = ""; 
    zipcode: string = ""; 
    city: string = ""; 
    country: string = ""; 
    contract:any[]=[];
    isDeleted: string = ""; 
    dbversion: string = ""; 
    currentdate: string = ""; 
    sessionID:string = ""; 
}